export default __webpack_public_path__ + "static/media/improve-interviewing-skills-featured.1e296222.png";